// Dependency-free module-license predicates shared across routes, pages, and data defs.
// Kept import-free so widely-imported modules (e.g. ActionData) don't eagerly pull in page components.

export const validatePatchModuleLicense = (has: (module: string) => boolean) =>
	has('patch_management') && (has('app_control') || has('vuln_assessment'));
